export { useCoverageType } from './useCoverageType';
